import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavComponent } from '../1.Nav/nav.component';
import { FooterComponent } from '../3.Footer/footer.component';

@Component({
  selector: 'app-user-layout',
  standalone: true,
  imports: [NavComponent, FooterComponent, RouterModule],
  templateUrl: './body-layout.component.html',
  styleUrl: './body-layout.component.css'
})
export class BodyLayoutComponent {

}
